module.exports = __webpack_public_path__ + "static/img/banner.35db569.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/banner.png
// module id = hILS
// module chunks = 10